import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { View } from 'react-native'
import Button from '@ui/buttons/Button'
import CodeInput from '@ui/forms/CodeInput/CodeInput'
import { CODE_LENGTH, VerifyContentProps } from './types'
import { useSubmitAuthCode } from './useSubmitAuthCode'

export default function MobileAuthContent({
  verifyRes,
  customer,
  replace = true,
  onSuccess,
}: VerifyContentProps) {
  const { t } = useTranslation(['auth'])

  const [code, setCode] = useState('')
  const [invalid, setInvalid] = useState(false)

  const { onSubmit, isLoading } = useSubmitAuthCode({
    login: verifyRes?.login || '',
    strategy: verifyRes?.strategy || 'phone',
    id: customer?.id,
    replace,
    onSuccess,
    onError: () => setInvalid(true),
  })

  const onPress = () => {
    if (code.length !== CODE_LENGTH) return
    onSubmit(code)
  }

  useEffect(() => {
    setInvalid(false)
    if (code.length === CODE_LENGTH) {
      onSubmit(code)
    }
  }, [code])

  return (
    <View className="items-center gap-16">
      <CodeInput
        invalid={invalid}
        length={CODE_LENGTH}
        value={code}
        setValue={setCode}
      />
      <Button
        label={t('auth:signIn')}
        iconEnd="arrow-narrow-right"
        onPress={onPress}
        loading={isLoading}
      />
    </View>
  )
}
